import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import UploadFileInput, { FileInputProps } from '@repo/ui/file-input'
import Typography from '@repo/ui/typography'
import React from 'react'

import { formatErrorMessage } from '../../../lib/utils/functions/format-error-message'
import { useFormField } from '../forms/form'

const ControlledFileInput: React.FC<Omit<FileInputProps, 'hasError'>> = ({ ...props }) => {
  const { error } = useFormField()
  const errorMessage = error?.message
  return (
    <div>
      <UploadFileInput {...props} hasError={!!error} />
      {errorMessage && (
        <Typography variant="small" color={tailwindColors.red.DEFAULT}>
          {formatErrorMessage(errorMessage)}
        </Typography>
      )}
    </div>
  )
}

export default ControlledFileInput
